import * as React from 'react';
import { Link } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const CancelAndReturnsModalContent = ()=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    const phone = getLabel('account.cancelAndReturns.phone', {
        hideLabelKey: true
    });
    const email = getLabel('account.cancelAndReturns.email', {
        hideLabelKey: true
    });
    const customerServiceKey = 'account.cancelAndReturns.customerService';
    const customerServiceLabelValue = getLabel(customerServiceKey);
    var ref;
    // we want to avoid making multiple labels when we're adding a url, we use one label and retrieve the text and url from it so we can pass it to the Link and Text component
    const [, customerServiceText, customerServiceUrl] = (ref = /\[(.*)\]\((.*)\)/.exec(customerServiceLabelValue)) !== null && ref !== void 0 ? ref : [];
    const isCustomerServiceVisible = customerServiceUrl && customerServiceText;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, getFormattedLabel('account.cancelAndReturns.description', {
        parseHTML: true
    })), isCustomerServiceVisible ? /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "user",
        href: customerServiceUrl
    }, customerServiceText)) : null, email ? /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "mail",
        href: `mailto:${email}`
    }, email)) : null, phone ? /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "phone-with-cord",
        href: `tel:${phone}`
    }, phone)) : null);
};
var CancelAndReturnsModalContent$1 = CancelAndReturnsModalContent;

export { CancelAndReturnsModalContent$1 as default };
//# sourceMappingURL=CancelAndReturnsModalContent.js.map
